import { AsyncForm, FormGroup } from '@components/async-form';
import { LoginWrapper } from '@course/components/login-wrapper';
import { rpx } from 'client/lib/rpx-client';
import { useState } from 'preact/hooks';
import { useDocumentTitle } from 'client/utils/use-document-title';
import { useIntl } from 'shared/intl/use-intl';
import { LoadedProps, RouteLoadProps, defRoute } from '@components/router';
import { StyledBrandButton } from '@course/components/styled-brand-button';
import { useCurrentTenant } from 'client/lib/auth';

export const route = defRoute({
  isPublic: true,
  load,
  Page,
});

async function load(route: RouteLoadProps) {
  const { courseId, brandId } = route.params;
  if (!courseId && !brandId) {
    return { brand: undefined };
  }

  const brand = await rpx.branding.getBrand({ courseId, brandId });
  return { brand };
}

function SigninLink({ brand }: { brand?: any }) {
  const intl = useIntl();
  return (
    <footer class="text-center block">
      <a
        href={`/login${location.search}`}
        style={{
          color: brand?.primaryActionColor,
          textDecoration: 'none',
        }}
      >
        {intl('← Sign in')}
      </a>
    </footer>
  );
}

function Page(props: LoadedProps<typeof load>) {
  const intl = useIntl();
  const [email, setEmail] = useState(props.params.email || '');
  const [emailSent, setEmailSent] = useState(false);
  const tenant = useCurrentTenant();
  const brand = props.state.brand || tenant;

  useDocumentTitle(['Forgot Your Password?']);

  return (
    <LoginWrapper brand={brand}>
      {emailSent && (
        <div class="flex flex-col gap-4">
          <h1 class="text-xl">{intl('Email sent!')}</h1>
          <p class="text-cool-gray-600">
            {intl('In a few minutes, a sign in link should arrive in your email inbox.')}
          </p>
          <SigninLink brand={brand} />
        </div>
      )}
      {!emailSent && (
        <AsyncForm
          class="flex flex-col gap-6"
          onSubmit={(data) => rpx.auth.forgotPassword(data).then(() => setEmailSent(true))}
        >
          <FormGroup prop="email">
            <label class="block text-sm font-medium text-gray-700 mb-1">{intl('Email')}</label>
            <input
              type="text"
              placeholder={intl('you@example.com')}
              name="email"
              value={email}
              onInput={(e: any) => setEmail(e.target.value)}
              class="ruz-input block w-full sm:text-sm sm:leading-5 bg-transparent py-3"
              data-private
            />
          </FormGroup>
          <StyledBrandButton brand={brand}>{intl('Email sign in link')}</StyledBrandButton>
          <SigninLink brand={brand} />
        </AsyncForm>
      )}
    </LoginWrapper>
  );
}
